import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog, Box, OutlinedInput, Typography, Stack } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import notifier from "../Notifier";
import {
  checkExtension,
  getErrorString,
  getUserDetail,
  isEmpty,
} from "../../constants/function";
import ApiService from "../../services/api-service";
import { Upload } from "react-iconly";
import Loader from "../Loader";
import { capitalize } from "lodash";
import ConfirmPlayListNft from "../ConfirmPlaylistNft";
import { Images } from "../../assets/common";
import DoneIcon from "@mui/icons-material/Done";
import "./index.scss";
import { Formik } from "formik";
import * as yup from "yup";
import { UserContext } from "../../context/userContext";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AddPopup(props) {
  const { t } = useTranslation("common");
  const [form, setForm] = React.useState({});
  const [confirm, setConfirm] = React.useState(false);
  const [image, setImage] = React.useState(null);
  const [file, setFile] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [explicit, setExplicit] = React.useState(null);
  const schema = yup.object().shape({
    isExplicit: yup.boolean(),
  });
  const userData = getUserDetail();

  const [name, setName] = React.useState(
    props["data"] ? props["data"]["title"] : ""
  );
  const save = async (values) => {
    const imgsize = file.size / 1024;
    if (imgsize > 6144) {
      notifier.error(t("notifier.error.toast12"));
      return;
    }
    if (typeof explicit !== "boolean") {
      notifier.error("The Explicit field is mandatory");
      return;
    }
    // console.log(values, "VAlues ::::::::");
    try {
      setLoading(true);
      const formData = new FormData();

      let response;
      if (props.api === "playlist") {
        handleOpenConfirm({
          title: name,
          file: file,
          isExplicit: values.isExplicit,
        });
        return;
      } else {
        formData.append("title", name);
        formData.append("thumbnailImg", file);
        formData.append("isExplicit", explicit);
        // if (!props["data"])
        //   formData.append(
        //     checkExtension(file["name"])[0] === "gif" ? "GIF" : "thumbnail",
        //     file
        //   );
        response = props["data"]
          ? await ApiService.EDIT_ALBUM(formData, props["data"]["_id"])
          : await ApiService.CREATE_ALBUM(formData);
        setLoading(false);
        notifier.success(
          props["data"]
            ? t("notifier.success.toast17")
            : t("notifier.success.toast18")
        );
        props.handleClose(
          response["result"],
          false,
          props["data"] ? name : null
        );
      }
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const update = async () => {
    try {
      const imgsize = file.size / 1024;
      if (imgsize > 6144) {
        notifier.error(t("notifier.error.toast12"));
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("GIF", file);
      formData.append("isExplicit", explicit);
      const response = await ApiService.EDIT_PLAYLIST(props["id"], formData);

      setLoading(false);
      notifier.success(t("notifier.success.toast16"));
      props.handleClose(
        props["selectedIndex"],
        false,
        response["result"]["GIF"],
        response["result"]["isExplicit"]
      );
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const handleOpenConfirm = (formData) => {
    setForm({ ...formData });
    setConfirm(true);
    setLoading(false);
  };
  const addNftPlaylist = (e, close) => {
    if (!e && !close) setConfirm(false);
    else props.handleClose(e, close);
  };
  function onFileChooser(id) {
    document.getElementById(id).click();
  }

  const onFileSelect = async (e, type) => {
    imageHandler(e.target.files[0], type);
  };

  async function imageHandler(e, type) {
    const reader = new FileReader();
    reader.onload = async function () {
      if (reader.readyState === 2) {
        if (type === "thumbnail") {
          setFile(e);
          setImage(reader.result);
        }
      }
    };
    reader.readAsDataURL(e);
  }

  React.useEffect(() => {
    setImage(props["image"] ? props["image"] : null);
    setExplicit(
      props["data"] ? props["data"]["isExplicit"] : props["isExplicit"]
    );
  }, []);

  let year = userData && userData["birthYear"] ? new Date().getFullYear() - userData["birthYear"] : 25; // Default to 25 if no user data (assume adult)

  return (
    <div>
      <Dialog
        onBackdropClick={() => props.handleClose(null, true)}
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => props.handleClose(null, false)}
        PaperProps={{
          style: {
            // backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#000000",
            borderRadius: 16,
            margin: "0",
            background: "#171515",
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <Stack spacing={1}>
          <Stack sx={{ padding: "16px" }} spacing={1}>
            <Stack spacing={1}>
              <Typography className="fs-16">{props.title}</Typography>
              {props["selectedIndex"] >= 0 ? null : (
                <DialogContent sx={{ padding: 0 }}>
                  <OutlinedInput
                    sx={{
                      width: "100%",
                      backgroundColor: "#262626",
                      height: "50px",
                    }}
                    autoFocus
                    margin="dense"
                    id="name"
                    placeholder={`${t("enter")} ${capitalize(
                      props.api === "playlist"
                        ? t("confirmPopup.text2")
                        : t("confirmPopup.text4")
                    )} ${t("name")}`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    autoComplete="off"
                  />
                </DialogContent>
              )}
            </Stack>
            {/* {props["selectedIndex"] >= 0 || props.api === "playlist" ? ( */}
            <Stack spacing={1}>
              <Typography className="fs-14">
                {props.api === "album"
                  ? t("addPopup.placeholder2")
                  : t("addPopup.placeholder1")}
              </Typography>
              <Box
                onClick={() => onFileChooser("thumbnail")}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  backgroundColor: "#262626",
                  borderRadius: "25px",
                  height: "50px",
                  alignItems: "center",
                  width: "350px",
                  height: "300px",
                }}
              >
                <Stack
                  direction="row"
                  sx={{
                    width: "100%",
                    height: "100%",
                    gap: "10px",
                    cursor: "pointer",
                  }}
                  alignItems="center"
                  justifyContent="center"
                >
                  {image ? (
                    <img
                      className="__selectedImg"
                      src={image}
                      alt={props["api"]}
                    />
                  ) : (
                    <Stack direction="column" justifyContent="center">
                      <img
                        src={Images.upload}
                        className="__input_icon __center_absolute"
                        alt=""
                      />
                      <Typography className="fs-13 __tap_select">
                        {t("addPopup.placeholder3")}
                      </Typography>
                    </Stack>
                  )}
                </Stack>

                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  id="thumbnail"
                  onChange={(e) => onFileSelect(e, "thumbnail")}
                  required
                />
              </Box>
            </Stack>
            <Stack direction="column" sx={{ marginTop: "10px" }}>
              <Formik
                validationSchema={schema}
                onSubmit={(Values) => {
                  save(Values);
                }}
                initialValues={{ isExplicit: explicit }}
              >
                {({ handleSubmit, values, setFieldValue }) => (
                  <Stack onSubmit={handleSubmit}>
                    {" "}
                    <Typography variant="body1" color="default">
                      {t("addPopup.explicit")}
                    </Typography>
                    <Stack direction="row" spacing={2}>
                      <Button
                        onClick={() => {
                          setFieldValue("isExplicit", true);
                          setExplicit(true);
                        }}
                        onChange={() => setExplicit(true)}
                        color="accent"
                        variant="contained"
                        sx={{
                          width: "50%",
                          justifyContent: "flex-start",
                          color:
                            values.isExplicit === "" ? "#FFFFFF50" : "#ffffff",
                        }}
                        startIcon={
                          values.isExplicit === true ? (
                            <DoneIcon
                              sx={{
                                backgroundColor: "#FFEE20",
                                borderRadius: "50%",
                                fontSize: "14px !important",
                                padding: "2px",
                                color: "#000000",
                              }}
                            />
                          ) : null
                        }
                        disabled={year < 18}
                      >
                        {t("addPopup.yes")}
                      </Button>
                      {year < 18 ? (
                        <Button
                          color="accent"
                          variant="contained"
                          sx={{
                            width: "50%",
                            justifyContent: "flex-start",
                            color: "#ffffff",
                          }}
                          defaultValue={setExplicit(false)}
                          startIcon={
                            <DoneIcon
                              sx={{
                                backgroundColor: "#FFEE20",
                                borderRadius: "50%",
                                fontSize: "14px !important",
                                padding: "2px",
                                color: "#000000",
                              }}
                            />
                          }
                        >
                          {t("addPopup.no")}
                        </Button>
                      ) : (
                        <Button
                          onClick={() => {
                            setFieldValue("isExplicit", false);
                            setExplicit(false);
                          }}
                          onChange={() => setExplicit(false)}
                          color="accent"
                          variant="contained"
                          sx={{
                            width: "50%",
                            justifyContent: "flex-start",
                            color:
                              values.isExplicit === ""
                                ? "#FFFFFF50"
                                : "#ffffff",
                          }}
                          startIcon={
                            values.isExplicit === false ? (
                              <DoneIcon
                                sx={{
                                  backgroundColor: "#FFEE20",
                                  borderRadius: "50%",
                                  fontSize: "14px !important",
                                  padding: "2px",
                                  color: "#000000",
                                }}
                              />
                            ) : null
                          }
                        >
                          {t("addPopup.no")}
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                )}
              </Formik>
            </Stack>
            {/* ) : null} */}
            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button
                sx={{ maxWidth: "150px", padding: "10px 35px" }}
                color="default"
                onClick={() => props.handleClose(null, false)}
              >
                {t("addPopup.cancel")}
              </Button>
              {props["selectedIndex"] >= 0 ? (
                <Button
                  sx={{ maxWidth: "150px", padding: "10px 35px" }}
                  variant="contained"
                  color="primary"
                  onClick={update}
                  disabled={!file["name"] && explicit === undefined}
                >
                  {t("addPopup.update")}
                </Button>
              ) : (
                <Button
                  sx={{ maxWidth: "150px", padding: "10px 35px" }}
                  variant="contained"
                  color="primary"
                  onClick={save}
                  // disabled={!file["name"]}
                  disabled={
                      props?.editAlbum && props["api"] === "album" 
                      ? !name && !file["name"] && explicit == null 
                      : props["api"] === "album"
                      ? !name || !file["name"] || explicit == null
                      : props["api"] === "playlist"
                      ? !name || !file["name"] || !explicit == null
                      : false
                  }
                >
                  {props.api === "playlist"
                    ? t("addPopup.create")
                    : t("addPopup.save")}
                </Button>
              )}
            </DialogActions>
          </Stack>
        </Stack>
      </Dialog>
      {loading ? <Loader /> : null}
      {confirm ? (
        <ConfirmPlayListNft
          data={explicit}
          open={confirm}
          form={form}
          handleClose={(e, close) =>
            !e && close ? setConfirm(true) : addNftPlaylist(e, close)
          }
        />
      ) : null}
    </div>
  );
}
